import { createContext } from 'react';

import { DEFAULT_HONEYCOMB_SHAPE } from '../constants.js';
import { HoneycombTileShape } from '../types/honeycomb.js';

export const HoneycombShapeContext = createContext<HoneycombTileShape>(
  DEFAULT_HONEYCOMB_SHAPE,
);
